var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./VisualizarEmpreendimento.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1a0cdb20\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./VisualizarEmpreendimento.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/empreendimentos/VisualizarEmpreendimento.vue
// module id = 1062
// module chunks = 1